/* eslint-disable class-methods-use-this */
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { Mode3DTool } from '../../../view3d/webcad/util/Mode3DTool';
import { optRecognizeMode } from '../../../view3d/webcad/util/Option3DInterface';

/**
 * 下絵編集ダイアログ（移動、回転、拡縮）
 */
export default class TempLidarPinControlDialog extends Dialog {
    MOVE_UNIT_1: number = 1;

    MOVE_UNIT_2: number = 2;

    MOVE_UNIT_3: number = 4;

    MOVE_UNIT_4: number = 10;

    TIME_PASSED_UNIT: number = 50;

    targetItem: marietta.webcad.item.TemporaryGroupItemForLidarAddPin;

    targetLayer: marietta.webcad.layer.LidarImportLayer;

    rotateTimer: any;

    timeoutId: any;

    timePassed: number;

    public cancelCallBack:Function;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      this.init();
    }

    /**
     * 初期設定
     */
    init() {
      // モーダルカラーを薄くする
      if (document.getElementById('modalBg')) {
        document.getElementById('modalBg').style.backgroundColor = '#000';
        document.getElementById('modalBg').style.opacity = '0.2';
      }

      // 対象の下絵を登録
      const { currentFloor } = marietta.webcad.WebCADGlobal.webcad2Dmanager;
      this.targetLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(currentFloor).layer_lidar_import;
      // eslint-disable-next-line prefer-destructuring
      this.targetItem = this.targetLayer.getchildList()[0];

      const id = 'dialogTempLidarPinController';
      let title = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Edit Position For Additional Pins'; break;
        default: title = '追加ピンの位置調整'; break;
      }

      let contents = '';
      contents += '<div class="controllerLeft">\n';
      contents += '<p class="controllerSubttl"><span class="jp">位置移動</span><span class="en">Move</span></p>\n';
      contents += '<div class="btnMoveWrap">\n';
      contents += '<button id="tempPinMoveUp" class="btnTempPinTransform btnUp">↑</button>\n';
      contents += '<button id="tempPinMoveDown" class="btnTempPinTransform btnDown">↓</button>\n';
      contents += '<button id="tempPinMoveLeft" class="btnTempPinTransform btnLeft">←</button>\n';
      contents += '<button id="tempPinMoveRight" class="btnTempPinTransform btnRight">→</button>\n';
      //イメージは表示しない
      contents += '<div id="tempPinMoveCenter" class="capCenter" style="display: none"></div>\n';
      contents += '</div>\n';

      contents += '</div>\n';
      contents += '<div class="controllerRight secondView">\n';
      contents += '<p class="controllerSubttl"><span class="jp">編集</span><span class="en">Edit</span></p>\n';
      contents += '<table>\n';
      contents += '<tbody>\n';
      contents += '<tr>\n';
      contents += '<td><button id="tempPinRotateLeft" class="btnTempPinTransform btnRotateL"></button><p class="btnName"><span class="jp">左回転</span><span class="en">Rotate L</span></p></td>\n';
      contents += '<td><button id="tempPinRotateRight" class="btnTempPinTransform btnRotateR"></button><p class="btnName"><span class="jp">右回転</span><span class="en">Rotate R</span></p></td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '</div>\n';

      const footer = '<button id="tempPinTransformCancel">キャンセル</button><button id="tempPinTransformConfirm">OK</button>';

      this.createDialog(id, title, contents, footer);

      // アクション
      const self = this;
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;

      if (ua.isMobile || ua.isTablet) {
        document.querySelectorAll('.btnTempPinTransform').forEach((element) => {
          element.addEventListener('touchstart', self.onMouseDownTransform);
        });
      } else {
        document.querySelectorAll('.btnTempPinTransform').forEach((element) => {
          element.addEventListener('mousedown', self.onMouseDownTransform);
        });
      }

      if (document.getElementById('tempPinTransformCancel')) document.getElementById('tempPinTransformCancel').addEventListener('click', self.controlHandlerTransformCancel);
      if (document.getElementById('tempPinTransformConfirm')) document.getElementById('tempPinTransformConfirm').addEventListener('click', self.controlHandlerTransformConfirm);
      ua = null;
    }

    /**
     * 変形ボタンが押された
     */
    onMouseDownTransform = (e) => {
      // 時間の経過のリセット
      this.timePassed = 0;

      const self = this;
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.querySelectorAll('.btnTempPinTransform').forEach((element) => {
          element.addEventListener('touchend', self.onMouseUpTransform);
        });
      } else {
        document.querySelectorAll('.btnTempPinTransform').forEach((element) => {
          element.addEventListener('mouseup', self.onMouseUpTransform);
        });
        document.querySelectorAll('.btnTempPinTransform').forEach((element) => {
          element.addEventListener('mouseout', self.onMouseUpTransform);
        });
      }
      ua = null;

      const targetBtnId: string = e.currentTarget.getAttribute('id');
      switch (targetBtnId) {
        case 'tempPinMoveUp':
          this.moveY(false);
          break;
        case 'tempPinMoveDown':
          this.moveY(true);
          break;
        case 'tempPinMoveLeft':
          this.moveX(false);
          break;
        case 'tempPinMoveRight':
          this.moveX(true);
          break;
        case 'tempPinRotateLeft':
          this.rotate(false);
          break;
        case 'tempPinRotateRight':
          this.rotate(true);
          break;
        default: return;
      }

      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.rotateTimer = setInterval(() => {
          switch (targetBtnId) {
            case 'tempPinMoveUp':
              this.moveY(false);
              break;
            case 'tempPinMoveDown':
              this.moveY(true);
              break;
            case 'tempPinMoveLeft':
              this.moveX(false);
              break;
            case 'tempPinMoveRight':
              this.moveX(true);
              break;
            case 'tempPinRotateLeft':
              this.rotate(false);
              break;
            case 'tempPinRotateRight':
              this.rotate(true);
              break;
            default:
          }
        }, 50);
      }, 200);
    }

    /**
     * マウスがUPされた
     */
    onMouseUpTransform = () => {
      const self = this;
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.querySelectorAll('.btnTempPinTransform').forEach((element) => {
          element.removeEventListener('touchend', self.onMouseUpTransform);
        });
      } else {
        document.querySelectorAll('.btnTempPinTransform').forEach((element) => {
          element.removeEventListener('mouseup', self.onMouseUpTransform);
        });
      }
      ua = null;

      clearTimeout(this.timeoutId);
      clearInterval(this.rotateTimer);
    }

    /**
    * 移動ボタンが押された
    * @param true = down, false = up;
    */
    moveY(down: boolean) {
      this.timePassed += this.TIME_PASSED_UNIT;
      let sokudo: number = this.MOVE_UNIT_1;
      let param: number;

      // 時間と共に回転を早くする
      if (this.timePassed > 3000) {
        sokudo = this.MOVE_UNIT_4;
      } else if (this.timePassed > 1000) {
        sokudo = this.MOVE_UNIT_3;
      } else if (this.timePassed > 500) {
        sokudo = this.MOVE_UNIT_2;
      }

      if (down) {
        param = this.targetItem.spt.y + sokudo;
      } else {
        param = this.targetItem.spt.y - sokudo;
      }
      this.targetItem.moveY(param);
    }

    /**
    * 移動ボタンが押された
    * @param true = right, false = left;
    */
    moveX(right: boolean) {
      this.timePassed += this.TIME_PASSED_UNIT;
      let sokudo: number = this.MOVE_UNIT_1;
      let param: number;

      // 時間と共に回転を早くする
      if (this.timePassed > 3000) {
        sokudo = this.MOVE_UNIT_4;
      } else if (this.timePassed > 1000) {
        sokudo = this.MOVE_UNIT_3;
      } else if (this.timePassed > 500) {
        sokudo = this.MOVE_UNIT_2;
      }

      if (right) {
        param = this.targetItem.spt.x + sokudo;
      } else {
        param = this.targetItem.spt.x - sokudo;
      }
      this.targetItem.moveX(param);
    }

    /**
    * 回転ボタンが押された
    * @param true = 時計回り, false = 反時計回り;
    */
    rotate(clockwise: boolean) {
      const unit: number = 90;
      let angle = this.targetItem.spt.rotation;
      if (clockwise) {
        angle += unit;
      } else {
        angle -= unit;
      }
      if (angle >= 360) angle %= 360;
      if (angle < 0) angle += 360;
      this.targetItem.rotate(angle);
    }

  /**
   * OKボタンが押された
   */
  controlHandlerTransformConfirm = () => {
    this.targetItem.insertPinsToPlan();
    const markList = this.targetItem.insertMarksToPlan();
    // 削除
    this.targetItem.deleteMe();

    this.close();

    if (markList.length > 0) { // 画像検知マークがあったら適用
      const mode3D = new Mode3DTool();
      const option: optRecognizeMode = {isRecogninzeMode: true, showWizardDialog: false, markList: markList};
      mode3D.setOption(option);
      mode3D.start();
    }
  }

  /**
   * Cancelボタンが押された
   */
  controlHandlerTransformCancel = () => {
    this.close();
  }

  /**
   * 閉じるボタンが押された
   */
  close = () => {
    if (this.cancelCallBack) {
      this.cancelCallBack();
    }
    this.closeEvent();
  }
}
